import { useQuery } from '@tanstack/react-query';
import { deliveryChargesService } from '../../services/deliveryChargesService';

export const useDeliveryChargeRules = () => {
  return useQuery({
    queryKey: ['delivery-charge-rules'],
    queryFn: () => deliveryChargesService.getRules(),
  });
};
